import { EnvironmentProviders } from '@angular/core';
import { provideQuillConfig, QuillModules } from 'ngx-quill/config';

/** Toolbar padrao da plataforma (sem video / imagem / codigo). */
export const PLATFORM_QUILL_TOOLBAR: NonNullable<QuillModules['toolbar']> = [
  ['bold', 'italic', 'underline', 'strike'],
  [{ header: [1, 2, 3, false] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ align: [] }],
  ['blockquote', 'link'],
  ['clean'],
];

export const PLATFORM_QUILL_FORMATS: readonly string[] = [
  'bold',
  'italic',
  'underline',
  'strike',
  'header',
  'list',
  'indent',
  'align',
  'blockquote',
  'link',
] as const;

export const DEFAULT_RICH_TEXT_MODULES: QuillModules = {
  toolbar: PLATFORM_QUILL_TOOLBAR,
};

export const DEFAULT_RICH_TEXT_PLACEHOLDER = 'Digite o texto...';

export const DEFAULT_RICH_TEXT_MIN_HEIGHT = '10rem';

/** Config global Quill (apps standalone via provideQuillConfig). */
export function providePlatformQuillConfig(): EnvironmentProviders {
  return provideQuillConfig({
    theme: 'snow',
    placeholder: DEFAULT_RICH_TEXT_PLACEHOLDER,
    sanitize: true,
    formats: [...PLATFORM_QUILL_FORMATS],
    modules: DEFAULT_RICH_TEXT_MODULES,
  });
}
